
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const onSelect = createOnFilter(onFilter)
  // const hasList = (list) => list.length > 0
  const { completedStatus } = filters
  console.log('[completedStatus]: ', completedStatus)

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {/* {hasList(completedStatus) && ( */}
        <MuiFormSelect
          id="completedStatus"
          label="Submission Status"
          emptyOptionLabel="All"
          includeEmptyOption
          options={['Completed', 'Not Completed']}
          value={filtered.completedStatus}
          onChange={onSelect('completedStatus')} />
        {/* )} */}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
